@if (involved) {
    <div class="d-flex mb-2">
        @for (item of choices; track item) {
            @if (involved[item.choice + 'm']) {
                <div class="d-flex flex-column mx-2 align-items-center">
                    <label>{{ item.label }} (M)</label>
                    <h6 class="font-weight-bold">{{ involved[item.choice + 'm'] }}</h6>
                </div>
            }
            @if (involved[item.choice + 'f']) {
                <div class="d-flex flex-column mx-2 align-items-center">
                    <label>{{ item.label }} (F)</label>
                    <h6 class="font-weight-bold">{{ involved[item.choice + 'f'] }}</h6>
                </div>
            }
        }
    </div>
}
